import { Seo } from "../Components/Seo";
import { SimpleGrid } from "@chakra-ui/react";
import { seoThumbnailUrl } from "../Components/imagesLink";

const Report = () => {
  return (
    <>
      <Seo
        title="Report - WpCalendar | Whatsapp chat to calendar events!"
        description="Effortlessly convert WhatsApp chat events to calendar events with our privacy-conscious tool. Keep track of important dates without compromising your data privacy."
        type="website"
        name="Soham_UltraHopeful"
        url="https://wpcalendar.vercel.app/report"
        imageUrl={seoThumbnailUrl}
      />
      <SimpleGrid mt={6} mx={4}>
        <iframe
          id="Iframe"
          title="report bug"
          src="https://www.cognitoforms.com/f/xbbF921xkkuccJM8KTs7Xw/1"
          width="100%"
          height="462"
        ></iframe>
      </SimpleGrid>
    </>
  );
};

export default Report;
